<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <switch-input v-model:checked="value" />
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem'
import FormLayout from '@/views/templates/FormLayout';
import SwitchInput from '@/views/atoms/inputs/SwitchInput'

export default {
  name: "VuexSwitchFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
  },
  components: {
    FormLayout,
    SwitchInput,
  }
}
</script>
